import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PharmacyApiConfiguration } from '../apiConfiguration';
import { ServiceBase } from 'app/shared/infrastructure';

@Injectable()
export class DoctorQuickPrescriptionService extends ServiceBase {

    private _actionUrl: string;
    private _url: string;
    private _getByIdUrl: string;
    private _addUrl: string;
    private _updateUrl: string;

    constructor(
        private _http: HttpClient,
        private _configuration: PharmacyApiConfiguration
    ) {
        super();
        this._actionUrl = _configuration.server;
        this._url = this._actionUrl + _configuration.doctorQuickPrescription.url;
        this._getByIdUrl = this._actionUrl + _configuration.doctorQuickPrescription.getById;
        this._addUrl = this._actionUrl + _configuration.doctorQuickPrescription.add;
        this._updateUrl = this._actionUrl + _configuration.doctorQuickPrescription.update;
    }

    getAll(): Observable<any[]> {
        return this._http.get<any[]>(this._url);
    }

    getById(id: number): Observable<any> {
        return this._http.get<any>(`${this._getByIdUrl}?id=${id}`);
    }

    create(dto: any): Observable<any> {
        return this._http.post<any>(this._addUrl, dto);
    }

    update(id: number, dto: any): Observable<any> {
        return this._http.put<any>(`${this._updateUrl}?id=${id}`, dto);
    }
}